import React from 'react';
import styled from 'styled-components';
import { Transition } from 'react-spring';
import { isActive, activity } from 'dooh-utils';
import { Tap } from './Tap';

document.addEventListener('click', activity);

const HiddenBack = styled(Tap)`
  position: absolute;
  top: 0;
  left: 0;
  width: 150px;
  height: 150px;
`;

export class ScreenRouter extends React.Component {
  static defaultProps = {
    hiddenBack: false,
  };

  constructor(props) {
    super(props);
    window.gotoScreen = this.handleGotoScreen;
  }

  render() {
    const CurrentScreen = this.getScreen();

    return (
      <React.Fragment>
        <Transition
          items={CurrentScreen}
          keys={this.getScreenName}
          from={{ opacity: 0 }}
          enter={{ opacity: 1 }}
          leave={{ opacity: 0 }}
        >
          {ShowScreen => props => (
            <ShowScreen
              {...this.props.screenProps || {}}
              key={this.getScreenName(ShowScreen)}
              style={props}
              gotoScreen={this.handleGotoScreen}
              gotoFirstScreen={this.handleGotoFirstScreen}
              gotoNextScreen={this.handleGotoNextScreen}
            />
          )}
        </Transition>

        {!this.props.hiddenBack ? null : (
          <HiddenBack
            key="_back"
            preventDoubleTap={false}
            onTap={this.handleGotoFirstScreen}
          />
        )}
      </React.Fragment>
    );
  }

  getScreenName(screen) {
    if (screen.screenName != null) {
      return screen.screenName;
    } else {
      throw new Error('Screen needs a name!');
    }
  }

  getScreen() {
    const screens = this.props.screens;
    return screens.find(s => this.getScreenName(s) === this.props.screen);
  }

  handleGotoScreen = screen => {
    activity();

    if (screen == null) {
      console.info(`No screen with ${screen}.`);
      return;
    }

    this.props.update(s => ({ ...s, screen }));
  };

  handleGotoFirstScreen = () => {
    const screen = this.getScreenName(this.props.screens[0]);
    this.props.update(s => ({ ...s, screen }));
  };

  handleGotoNextScreen = () => {
    activity();

    const screens = this.props.screens,
      i = screens.findIndex(s => this.getScreenName(s) === this.props.screen);
    if (i === -1) {
      console.warning(`No screen with name ${this.props.screen}.`);
      return;
    }
    let screen = this.getScreenName(screens[(i + 1) % screens.length]);
    this.props.update(s => ({ ...s, screen }));
  };
}

const ScreenWrap = styled.div`
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  width: ${p => p.width}px;
  height: ${p => p.height}px;

  & * {
    tap-highlight-color: rgba(0, 0, 0, 0);
  }
`;

export function screen(Screen, screenName, props = {}) {
  class NamedScreen extends React.Component {
    static screenName = screenName;

    static defaultProps = {
      width: 1080,
      height: 1920,
    };

    componentDidMount() {
      if (props.timeout != null) {
        this.timeoutInterval = setInterval(this.checkActivity, 1000);
      }

      if (props.timer != null) {
        this.timerHandle = setTimeout(this.props.gotoNextScreen, props.timer);
      }
    }

    componentWillUnmount() {
      if (props.timeout != null) {
        clearInterval(this.timeoutInterval);
      }

      if (props.timerHandle != null) {
        clearTimeout(this.timerHandle);
      }
    }

    render() {
      const { width, height, style } = this.props;
      return (
        <ScreenWrap width={width} height={height} style={style}>
          <Screen {...props} {...this.props} />
        </ScreenWrap>
      );
    }

    checkActivity = () => {
      if (!isActive(props.timeout)) {
        if (window.track) {
          const meta = Object.assign({ screen: screenName }, this.props);
          window.track('timeout', meta);
        }
        this.props.gotoFirstScreen();
      }
    };
  }

  NamedScreen.displayName = `Screen(${screenName})`;

  return NamedScreen;
}
